import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { Router, ActivatedRoute} from '@angular/router';
import * as $ from 'jquery';
import { MsalService } from '@azure/msal-angular';
import { AboutComponent } from '../about/about.component';
import { Globals } from '../models/globals.model';
import { GlobalService } from '../services/global.service';
import { ThemeService } from '../services/theme.service';
import { AlertComponent } from '../common/alert/alert.component';
import { MLService } from '../services/ml-service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit {
  @Input() data: string;
  userName: string;
  userShortName: string;
  unreadNotifications: number = 0;
  rbacName: string = '';
  countryCode: any;
  countryList: any;
  releaseDetails: any;
  zeroNotification = false;
  errorNotification = false;
  displayDefaultUser: any = [];
  notificationLimit = 10;
  hideNotificationNumber = false;
  dateString: string;
  constructor(private readonly authService: MsalService, public mlService: MLService,
    public dialog: MatDialog, public globals: Globals, public globalService: GlobalService,
    public themeService: ThemeService, public _router: Router,
    public route: ActivatedRoute) {
    this.countryList = [      
      {
        "Id": 1,
        "Name": "English",
        "Code": "EN",
      }
    ];

  }

  ngOnInit() {
    this.themeService.setLightTheme();
    this.getReleaseDetails();
    this.countryCode = "EN";
    $('#handberg').click(function () {
      $('.row-offcanvas').toggleClass('active');
      $('.collapse').toggleClass('in').toggleClass('hidden-xs').toggleClass('visible-xs');
    });

    $("#close-sidebar").click(function () {
      $(".page-wrapper").removeClass("toggled");
    });
    $("#show-sidebar").click(function () {
      $(".page-wrapper").addClass("toggled");
    });
  }

  logout() {
    this.authService.logout();
  }
  
  // show about dialog for version, build date and build number
  openAboutRelease(): void {   
     this.dialog.open(AboutComponent, {
        data: this.releaseDetails,
      });
    
  }

  getReleaseDetails() {
    this.releaseDetails = this.globals.releaseDetails;
  }

  selectFlag(Code: any) {
    this.countryCode = Code;
  }

  toggleTheme() {
    if (this.themeService.isDarkTheme()) {
      this.themeService.setLightTheme();
    } else {
      this.themeService.setDarkTheme();
    }
  }

  /**
   * Triggered whenever a change occurs
   * @param changes
   */
 
    
}

